import React from 'react';
// import Partners from '../../../pages/people-partners/Partners';
import Partners from '../../../pages/partners/Partners';
import Educators from '../../../pages/educators/Educators';
import { PayloadStates } from '@lore/utils';
import Loader from '../../../components/Loader';
import useMissingFields from '../../project_manage/useMissingFields';
import EmptyState from '../../_common/EmptyState';
import Results from '../../../pages/_common_results/Results';
import User from '../../../pages/_common_user/ManageUser';
import Filters from '../../../forms/filters_educators';
import { AcademicCapIcon, FolderIcon } from '@heroicons/react/24/outline';
import { useConnect } from '@lore/query-connect';
import useRouter from '../../../hooks/useRouter';
import classNames from 'classnames';
import PaginationInformation from '../../../components/pagination-new/PaginationInformation';
import SortBy from '../../../pages/educators/SortBy';
import FilterButton from '../../../pages/_common_filters/FilterButton';
import Project from '../../../pages/projects/Project';

export default function Layout(props) {
  const { site } = props;

  const router = useRouter();

  // const { missingFields } = useMissingFields(project);

  // if (site.state === PayloadStates.FETCHING) {
  //   return (
  //     <Loader />
  //   );
  // }

  // if (missingFields.data.length > 0) {
  //   return (
  //     <EmptyState
  //       title="Project is missing required fields."
  //       subtitle="They must be provided before you can invite partners."
  //     />
  //   );
  // }

  const pageSize = 100;

  const result = useConnect('project.find', {
    where: {
      eager: {
        $where: {
          siteId: site.id,
          activityId: {
            $null: false
          }
        }
      }
    },
    pagination: {
      pageSize: pageSize,
      order: 'createdAt desc'
    }
  });

  if (result.data.length === 0) {
    return (
      <EmptyState
        icon={AcademicCapIcon}
        title="There are no projects linked to this site."
        subtitle="Check back later."
      />
    );
  }

  const columns = 1;

  return (
    <>
      <div className="flex flex-wrap gap-4 justify-between items-end">
        <PaginationInformation
          pageSize={pageSize}
          totalCount={result.meta?.totalCount}
        />
      </div>
      <div className={classNames(
        result._isPreviousData && 'opacity-50',
        'w-full grid grid-cols-1 gap-4',
        columns > 1 && 'sm:grid-cols-2',
        columns > 2 && 'lg:grid-cols-3',
        columns > 3 && 'xl:grid-cols-4',
      )}>
        {result.data.map(function(project, index) {
          return (
            <Project
              key={index}
              project={project}
            />
          );
        })}
      </div>
    </>
  );
};
